import React from 'react';
import { Button, Collapse } from 'antd';

const { Panel } = Collapse;

export interface ExpansionPanelProps {
  children?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  buttonLabel?: string;
  onChange?: (arg0: boolean) => void;
  value?: boolean;
}

const ExpansionPanel: React.FC<ExpansionPanelProps> = ({
  children,
  title,
  subtitle,
  buttonLabel = 'Expand',
  onChange = () => false,
  value, // If value prop is provided, component becomes controlled by parent
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const [isControlled, setControlled] = React.useState(false);

  React.useEffect(() => {
    if (typeof value === 'boolean') {
      setControlled(true);
      setExpanded(value);
    }
  }, [value]);

  const expand = () => {
    const newExpanded = !expanded;
    if (isControlled) {
      onChange(newExpanded);
    } else {
      setExpanded(newExpanded);
    }
  };

  const renderHeaderIcon = () => {
    const suffix = ' expansion-panel-icon';
    const editIcon = `glyphicon glyphicon-pencil ${suffix}`;
    const expandedIcon = `glyphicon glyphicon-chevron-down ${suffix}`;

    const className = expanded ? expandedIcon : editIcon;

    return <span className={className} aria-hidden="true"></span>;
  };

  return (
    <div className="expansion-panel panel panel-default">
      <div className="expansion-panel-header">
        <div>
          <div>{title}</div>
          <div>{subtitle}</div>
        </div>
        <div>
          <Button
            type="link"
            onClick={expand}
            className="expansion-panel-expand-button"
          >
            <span className="expansion-panel-button-label">{buttonLabel} </span>{' '}
            {renderHeaderIcon()}
          </Button>
        </div>
      </div>
      <Collapse
        activeKey={expanded ? 1 : 0}
        className="expansion-panel-content"
      >
        <Panel header="" key={1}>
          {children}
        </Panel>
      </Collapse>
    </div>
  );
};

// ExpansionPanel.propTypes = {
//   children: PropTypes.node,
//   title: PropTypes.node,
//   subtitle: PropTypes.node,
//   buttonLabel: PropTypes.string,
// };

export default ExpansionPanel;
